import { isValidElement } from 'react';
import { styled, keyframes } from '@mui/material/styles';

// const SpinWrapper = styled('div')(({ theme, rotationTime = '1s', inverted = false }) => ({
//   display: 'inline-block',
//   animation: `spin ${rotationTime} linear infinite`,
//   '@keyframes spin': {
//     from: {
//       transform: `${inverted ? 'rotate(360deg)' : 'rotate(0deg)'}`,
//     },
//     to: {
//       transform: `${inverted ? 'rotate(0deg)' : 'rotate(360deg)'}`,
//     },
//   },
// }));

const SpinWrapper = styled('div')(
  ({ rotationTime = '1s', inverted = false, disableSpin = false }) => {
    const spinAnimation = keyframes`
      from { transform: rotate(${inverted ? 360 : 0}deg); }
      to { transform: rotate(${inverted ? 0 : 360}deg); }
    `;

    return {
      display: 'inline-block',
      animation: disableSpin ? 'none' : `${spinAnimation} ${rotationTime} linear infinite`,
    };
  }
);

/**
 * IconSpinning
 *
 * Componente para animar un ícono giratorio.
 *
 * @component
 * @param {string} [className] - Clases CSS adicionales para el wrapper
 * @param {string} [rotationTime] - Duración de la animación (ej: '1s')
 * @param {boolean} [inverted] - Si la animación es invertida
 * @param {boolean} [disableSpin] - Si se quiere desactivar la animación
 * @param {React.ReactNode} children - Ícono a girar (debe ser un elemento React válido)
 * @param props
 * @returns {JSX.Element}
 */
export const IconSpinning = ({
  className,
  rotationTime,
  inverted,
  children,
  disableSpin = false,
  ...props
}) => {
  if (!isValidElement(children)) {
    throw new Error('The children prop must be a valid React element.');
  }
  return (
    <SpinWrapper
      rotationTime={rotationTime}
      inverted={inverted}
      disableSpin={disableSpin}
      className={className}
      {...props}
    >
      {children}
    </SpinWrapper>
  );
};
